import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../utils/itemValidation';

import * as commonActionCreators from '../../../actions/common';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, usersActionCreators);

class Invite extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: this.props.common.inviteOpen,
      closing: false,
      inputYourName: '',
      inputFriendsName: '',
      inputFriendsEmail: '',
      errorYourName: null,
      errorFriendsName: null,
      errorFriendsEmail: null,
    };
  }

  getInviteClass() {
    if(this.state.closing) {
      return 'Invite closing';
    } else {
      return this.props.common.inviteOpen ? 'Invite open' : 'Invite closed';
    }
  }

  closeInvite() {
    this.setState({ closing: true });
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
      }, () => {
        this.props.commonCloseInvite();
      });
    }, 500)
  }

  catchClick(evt) {
    evt.stopPropagation();
  }

  changeYourName(evt) {
    this.setState({ inputYourName: evt.target.value }, () => {
      if(this.state.errorYourName && !nameValidation(this.state.inputYourName)) {
        this.setState({ errorYourName: null });
      }
    });
  }

  changeFriendsName(evt) {
    this.setState({ inputFriendsName: evt.target.value }, () => {
      if(this.state.errorFriendsName && !nameValidation(this.state.inputFriendsName)) {
        this.setState({ errorFriendsName: null });
      }
    });
  }

  changeFriendsEmail(evt) {
    this.setState({ inputFriendsEmail: evt.target.value }, () => {
      if(this.state.errorFriendsEmail && !emailValidation(this.state.inputFriendsEmail)) {
        this.setState({ errorFriendsEmail: null });
      }
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let yourNameError = nameValidation(this.state.inputYourName);
    let friendsNameError = nameValidation(this.state.inputFriendsName);
    let friendsEmailError = emailValidation(this.state.inputFriendsEmail);
    

    if(yourNameError === null &&
       friendsNameError === null &&
       friendsEmailError === null) {
      hasErrors = false;
    }

    this.setState({
      errorYourName: yourNameError,
      errorFriendsName: friendsNameError,
      errorFriendsEmail: friendsEmailError,
    });

    return !hasErrors;
  }

  submitInviteRequest() {
    if(this.validateAll()) {

      let inviteData = {
        user_name: this.state.inputYourName,
        friend_name: this.state.inputFriendsName,
        friend_email: this.state.inputFriendsEmail,
      }

      this.props.usersInviteRequest(inviteData);
      this.props.commonAlert('Your invitation has been sent.', 'Continue Browsing');
      this.setState({
        inputYourName: '',
        inputFriendsName: '',
        inputFriendsEmail: '',
        errorYourName: null,
        errorFriendsName: null,
        errorFriendsEmail: null,
      });
      this.props.commonCloseInvite();
    }
  }

  render() {
    return <div className={::this.getInviteClass()} onClick={::this.closeInvite}>
      <div className='contactBody' onClick={::this.catchClick}>
        <div className='closeInvite' onClick={::this.closeInvite}>
          <div className='closeX'>&times;</div>
        </div>
        <div className='formWrapper'>
          <div className='formLogo'>
            <img src='/img/luxury2022/intro1/title.svg' alt='Diamonds Direct' />
          </div>
          <div className='formBody'>
            <div className='formTitle'>Invite a Friend to Experience the Collection</div>
            <div className='formRow'>
              <input 
                className={this.state.errorYourName ? 'textInput error' : 'textInput'}
                type='text' 
                placeholder='ENTER YOUR NAME'
                value={this.state.inputYourName}
                onChange={::this.changeYourName} />
            </div>
            <div className='formRow'>
              <input 
                className={this.state.errorFriendsName ? 'textInput error' : 'textInput'}
                type='text' 
                placeholder="ENTER YOUR FRIEND'S NAME"
                value={this.state.inputFriendsName}
                onChange={::this.changeFriendsName} />
            </div>
            <div className='formRow'>
              <input 
                className={this.state.errorFriendsEmail ? 'textInput error' : 'textInput'}
                type='email' 
                placeholder="ENTER YOUR FRIEND'S EMAIL"
                value={this.state.inputFriendsEmail}
                onChange={::this.changeFriendsEmail} />
            </div>
            <div className='formRow'>
              <div 
                className={'contactSubmit actionButton'}
                onClick={::this.submitInviteRequest}>Send</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
export default Invite;

function mapStateToProps(state) {
  return {
    common: state.common
  };
}

export const InviteContainer = connect(
  mapStateToProps,
  allActionCreators
)(Invite);


// WEBPACK FOOTER //
// ./src/components/views/invite/Invite.jsx